var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "watchPhoneNumber" },
    [
      !_vm.isSave
        ? _c("div", [
            _c("span", { staticClass: "phoneNumber" }, [
              _vm._v(" " + _vm._s(_vm.email) + " "),
            ]),
            !_vm.isReal && _vm.email
              ? _c("i", {
                  staticClass: "pointer",
                  class: _vm.loading ? "el-icon-loading" : "el-icon-view",
                  on: { click: _vm.onClick },
                })
              : _vm._e(),
          ])
        : _c("el-input-number", {
            attrs: {
              "controls-position": "right",
              min: 1,
              "step-strictly": true,
              controls: false,
            },
            model: {
              value: _vm.newEmail,
              callback: function ($$v) {
                _vm.newEmail = $$v
              },
              expression: "newEmail",
            },
          }),
      _vm.setEmail && _vm.emailAuthority && !_vm.isSave
        ? _c("i", {
            directives: [
              {
                name: "permission",
                rawName: "v-permission",
                value: [_vm.emailAuthority, _vm.permsList],
                expression: "[emailAuthority, permsList]",
              },
            ],
            staticClass: "el-icon-edit pointer c_0F71FF edit",
            on: { click: _vm.handleEditEmail },
          })
        : _vm._e(),
      _vm.setEmail && !_vm.emailAuthority && !_vm.isSave
        ? _c("i", {
            staticClass: "el-icon-edit pointer c_0F71FF edit",
            on: { click: _vm.handleEditEmail },
          })
        : _vm._e(),
      _c("div", [
        _vm.setEmail && _vm.isSave
          ? _c("div", { staticClass: "edit", on: { click: _vm.handleSave } }, [
              _vm._v("保存"),
            ])
          : _vm._e(),
        _vm.setEmail && _vm.isSave
          ? _c(
              "div",
              {
                staticClass: "edit",
                on: {
                  click: function ($event) {
                    _vm.isSave = false
                  },
                },
              },
              [_vm._v(" 取消 ")]
            )
          : _vm._e(),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }